export default __webpack_public_path__ + "ffaf9d4b4ae071d0a2eafb843fb164f3.svg";